<template>
  <v-form ref="form" class="">
    <v-row>
      <v-col cols="12" class="">
        <v-card outlined>
          <v-card-title class="py-2">
            <span class="font-weight-bold body-1">Informações do Item</span>
          </v-card-title>

          <v-card-text>
            <v-row>

              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  v-model="entry.taxationRule.taxationGroup.ncm.text"
                  label="NCM"
                  readonly
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.otherExpensesValueText"
                  label="Outras Despesas"
                  readonly
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.discountValueText"
                  label="Valor do Desconto"
                  readonly
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.carriageValueText"
                  label="Valor Total do Frete"
                  readonly
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.insuranceValueText"
                  label="Valor do Seguro"
                  readonly
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>



      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="py-2">
            <span class="font-weight-bold body-1">Indicador de Composição do Valor Total da NF-e</span>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="entry.item.barcode"
                  label="Código EAN Comercial"
                  readonly
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="entry.taxationRule.taxationGroup.ncm.taxUnit"
                  label="Unidade Comercial"
                  readonly
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.quantityText"
                  label="Quantidade Comercial"
                  readonly
                />
                <!-- <MaskedTextField
                  :inputData.sync="entry.quantity"
                  mask-type="currency"
                  label="Quantidade Comercial"
                  readonly
                /> -->
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="entry.item.barcode"
                  label="Código EAN Tributável"
                  readonly
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="entry.taxationRule.taxationGroup.ncm.taxUnit"
                  label="Unidade Tributável"
                  readonly
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.quantityText"
                  label="Quantidade Tributável"
                  readonly
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.unitPriceText"
                  label="Valor Unitário de Comercialização"
                  readonly
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.unitPriceText"
                  label="Valor Unitário de Tributação"
                  readonly
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>


      <!-- <v-col cols="4">
        <v-text-field
          v-model="entry.level"
          v-bind="getObject('level')"
          label="Nível"
        />
      </v-col> -->

      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="py-2">
            <span class="font-weight-bold body-1">ICMS</span>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <!-- Normal e ST -->
                <v-text-field
                  v-model="entry.taxationRule.icmsOrigin.text"
                  label="Origem da Mercadoria"
                  readonly
                />
              </v-col>

              <v-col cols="12" sm="6">
                <!-- Normal e ST -->
                <v-text-field
                  v-model="entry.taxationRule.icmsCst.text"
                  label="Tributação do ICMS"
                  readonly
                />
              </v-col>

              <v-col cols="12" sm="12">
                <v-card outlined>
                  <v-card-title class="py-2">
                    <span class="font-weight-bold body-1">ICMS Normal</span>
                  </v-card-title>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          :value="entry.taxationRule.icmsModBc ? entry.taxationRule.icmsModBc.text : ''"
                          label="Modalidade de determinação da BC do ICMS"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          :value="entry.taxationRule.icmsPredBcText"
                          label="Perc. da Redução da BC"
                          readonly
                          prefix="%"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          :value="entry.icmsVbcText"
                          label="Valor da BC do ICMS"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          v-model="entry.taxationRule.icmsPicmsText"
                          label="Alíquota do Imposto"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          :value="entry.icmsVicmsText"
                          label="Valor do ICMS"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          :value="entry.icmsVicmsOpText"
                          label="Valor do ICMS da Operação"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          :value="entry.taxationRule.icmsPdifText"
                          label="Percentual do Diferimento"
                          readonly
                          prefix="%"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          :value="entry.icmsVicmsDifText"
                          label="Valor do ICMS Diferido"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          :value="entry.icmsVbcFcpText"
                          label="Valor da Base de Cálculo do FCP"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          :value="entry.taxationRule.icmsPfcpText"
                          label="Perc. do Fundo de Combate à Pobreza (FCP)"
                          readonly
                          prefix="%"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <!-- ICMS Normal -->
                        <v-text-field
                          :value="entry.icmsVfcpText"
                          label="Valor do Fundo de Combate à Pobreza (FCP)"
                          readonly
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-card outlined>
                  <v-card-title class="py-2">
                    <span class="font-weight-bold body-1">ICMS ST</span>
                  </v-card-title>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          :value="entry.taxationRule.icmsModBcSt ? entry.taxationRule.icmsModBcSt.text : ''"
                          label="Modalidade de determinação da BC do ICMS em ST"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          :value="entry.taxationRule.icmsPredBcStText"
                          label="Perc. da Redução de BC do ICMS ST"
                          readonly
                          prefix="%"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          :value="entry.icmsVbcStText"
                          label="Valor da BC do ICMS ST"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="entry.taxationRule.icmsPicmsStText"
                          label="Alíquota do Imposto do ICMS ST"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          :value="entry.icmsVicmsStText"
                          label="Valor do ICMS ST"
                          readonly
                        />
                      </v-col>

                      <!-- <v-col cols="4">
                        <v-text-field
                          :value="entry.icmsVicmsOpText"
                          label="Valor do ICMS da Operação"
                          readonly
                        />
                      </v-col> -->

                      <!-- <v-col cols="4">
                        <v-text-field
                          :value="entry.taxationRule.icmsPdifText"
                          label="Percentual do Diferimento"
                          readonly
                          prefix="%"
                        />
                      </v-col> -->

                      <!-- <v-col cols="4">
                        <v-text-field
                          :value="entry.icmsVicmsDifText"
                          label="Valor do ICMS Diferido"
                          readonly
                        />
                      </v-col> -->

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          :value="entry.icmsVbcFcpStText"
                          label="Valor da Base de Cálculo do FCP retido por Substituição Tributária"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          :value="entry.taxationRule.icmsPfcpStText"
                          label="Perc. do FCP retido por Substituição Tributária"
                          readonly
                          prefix="%"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          :value="entry.icmsVfcpStText"
                          label="Valor do FCP retido por Substituição Tributária"
                          readonly
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="py-2">
            <span class="font-weight-bold body-1">PIS</span>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="entry.taxationRule.pisCst.text"
                  label="CST"
                  readonly
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.pisVbcText"
                  label="Base de Cálculo"
                  readonly
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.taxationRule.pisPpisText"
                  label="Alíquota"
                  readonly
                  prefix="%"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.pisVpisText"
                  label="Valor do PIS"
                  readonly
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="py-2">
            <span class="font-weight-bold body-1">COFINS</span>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="entry.taxationRule.cofinsCst.text"
                  label="CST"
                  readonly
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.cofinsVbcText"
                  label="Base de Cálculo"
                  readonly
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.taxationRule.cofinsPcofinsText"
                  label="Alíquota"
                  readonly
                  prefix="%"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  :value="entry.cofinsVcofinsText"
                  label="Valor"
                  readonly
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>

  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue";

export default {
  data() {
    return {
      entryAttributes: {}
    };
  },
  props: {
    entry: Object,
    extraData: Object,
  },
  components: {
    MaskedTextField: MaskedTextField,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
